import { render, staticRenderFns } from "./iconNotFound.vue?vue&type=template&id=2b7ab85a&"
import script from "./iconNotFound.vue?vue&type=script&lang=js&"
export * from "./iconNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports